module.exports = __webpack_public_path__ + "static/img/nonet.052974e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nonet.png
// module id = sa79
// module chunks = 1